import React, { Component } from 'react';
export default class StickyContainer extends Component {
    render() {
        const { top, children } = this.props;
        return (<div style={{
            position: 'sticky',
            top: top ? Number(top) : 54,
            zIndex: 999,
            backgroundColor: '#fff',
            width: '100%',
            padding: '0 70px',
        }}>
                {children}
            </div>);
    }
}
